import React from "react";
import "../Styles/Info.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faUserCheck,
  faBriefcase,
  faComments,
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";

function Info() {
  return (
    <div className="info-section" id="services">
      <div className="info-title-content">
        <h3 className="info-title">
          <span>Our Services</span>
        </h3>

        <p className="info-description">
          We help businesses hire with greater clarity, confidence, and precision by bringing
          structure to the recruitment process and making it easier to manage at every stage. Our
          approach begins with a detailed understanding of your requirements — from the role
          and skill expectations to the kind of talent that best fits your business culture and goals.
          From there, we focus on sourcing relevant candidates, assessing alignment with care,
          and managing each step with consistency, professionalism, and attention to detail. The
          result is a refined hiring experience that feels efficient, dependable, and well-executed
          from start to finish.
        </p>

        <div className="info-points">
          <p>
            <strong>
              <FontAwesomeIcon icon={faSearch} className="info-icon" /> Talent Sourcing:
            </strong>{" "}
            We identify relevant talent aligned with the role, business goals, and industry needs,
            ensuring every search starts with focus and purpose.
          </p>

          <p>
            <strong>
              <FontAwesomeIcon icon={faUserCheck} className="info-icon" /> Candidate Screening Support:
            </strong>{" "}
            We review profiles and support initial screening to ensure candidates match expectations
            and improve hiring quality.
          </p>

          <p>
            <strong>
              <FontAwesomeIcon icon={faBriefcase} className="info-icon" /> Industry-Specific Hiring Support:
            </strong>{" "}
            We support hiring across multiple sectors with an approach shaped by industry realities
            and expectations.
          </p>

          <p>
            <strong>
              <FontAwesomeIcon icon={faComments} className="info-icon" /> Recruitment Coordination:
            </strong>{" "}
            We manage the hiring process with structured communication, smooth coordination,
            and consistent follow-ups.
          </p>

          <p>
            <strong>
              <FontAwesomeIcon icon={faUserShield} className="info-icon" /> Confidential Hiring Assistance:
            </strong>{" "}
            We handle sensitive hiring needs with full discretion, ensuring privacy while maintaining
            efficient progress.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Info;